/**
 * Auth0 connect field validation (AUTH0.IMPL.3).
 */

const DOMAIN_RE = /^[a-z0-9][a-z0-9.-]*\.(us|eu|au)\.auth0\.com$/i;

/**
 * @param {{ tenant_domain?: string, client_id?: string, client_secret?: string }} fields
 */
export function validateAuth0ConnectFields(fields) {
  const tenant_domain = String(fields?.tenant_domain || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "");
  const client_id = String(fields?.client_id || "").trim();
  const client_secret = String(fields?.client_secret || "").trim();

  if (!tenant_domain) {
    return { ok: false, error: "Auth0 tenant domain is required." };
  }
  if (!DOMAIN_RE.test(tenant_domain) && !tenant_domain.includes("auth0.com")) {
    return { ok: false, error: "Enter a valid Auth0 tenant domain (e.g. your-tenant.us.auth0.com)." };
  }
  if (!client_id) {
    return { ok: false, error: "M2M Client ID is required." };
  }
  if (!client_secret || client_secret.length < 8) {
    return { ok: false, error: "M2M Client Secret is required." };
  }
  return { ok: true, tenant_domain, client_id, client_secret };
}

/**
 * @param {Record<string, unknown>} data
 */
export function mapAuth0ConnectApiError(data) {
  if (typeof data?.error === "string" && data.error.trim()) return data.error;
  return "Connection failed";
}
